module.exports = __webpack_public_path__ + "static/media/pin_carclinic_highlighted.1d286b8d.png";